import { render } from "./addMenu.vue?vue&type=template&id=2cee3ad6&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"

import "./addMenu.vue?vue&type=style&index=0&id=2cee3ad6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cee3ad6"]])

export default __exports__